import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Avatar,
  Box,
  Button,
  Divider,
  Flex,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  StackDivider,
  Text,
  useToast,
  VStack,
} from "@chakra-ui/react";
import { ChangeEvent, useEffect, useState } from "react";
import { BsCheck, BsPlus } from "react-icons/bs";
import { RiSearch2Line } from "react-icons/ri";
import { IUserProfile } from "../../../models/admin/user.model";
import { IAvailableCourse } from "../../../models/trainee-course.model";
import AdminHelpers from "../../../services/admin/admin.service";
import { EmptySearchResult } from "../../EmptySearchResult";

export const AssignCourseModal: React.FC<any> = ({
  isOpened,
  onClosed,
  selectedCourseId,
  trainerIds,
  updateRecord,
}: {
  isOpened: any;
  onClosed: any;
  selectedCourseId: any;
  trainerIds: string[];
  updateRecord: any;
}) => {
  const [isSearchEmpty, setIsSearchEmpty] = useState(false);
  const [trainers, setTrainers] = useState<IUserProfile[]>([]);
  const [trainersMemo, setTrainersMemo] = useState<IUserProfile[]>([]);
  const [filteredTrainers, setFilteredTrainers] = useState<IUserProfile[]>([]);
  const [pickedTrainers, setPickedTrainers] = useState<IUserProfile[]>([]);
  const [availableCourse, setAvailableCourses] = useState<IAvailableCourse[]>(
    []
  );
  const [isEnrolling, setIsEnrolling] = useState(false);

  const [geotrainers, setGeoTrainers] = useState<IUserProfile[]>([]);
  const [biofueltrainers, setBiofuelTrainers] = useState<IUserProfile[]>([]);
  const [biomasstrainers, setBiomassTrainers] = useState<IUserProfile[]>([]);
  const [solartrainers, setSolarTrainers] = useState<IUserProfile[]>([]);
  const [hydrotrainers, setHydroTrainers] = useState<IUserProfile[]>([]);
  const [windtrainers, setWindTrainers] = useState<IUserProfile[]>([]);
  const [operation, setOperationTypes] = useState("");

  const toast = useToast();

  useEffect(() => {
    
    AdminHelpers.getTrainers()
      .then((res) => {
        
        const all_trainers = res.data;
        const geothermal_trainers: IUserProfile[] = [];
        const biofuel_trainers: IUserProfile[] = [];
        const biomass_trainers: IUserProfile[] = [];
        const solar_trainers: IUserProfile[] = [];
        const hydro_trainers: IUserProfile[] = [];
        const wind_trainers: IUserProfile[] = [];
        for (let index = 0; index < all_trainers.length; index++) {
          const trainer = all_trainers[index];
          if (trainer.specialities.length > 0) {
            for (let j = 0; j < trainer.specialities.length; j++) {
              
              if ((trainer.specialities[j].speciality_id === 1)) {
                biofuel_trainers.push(trainer);
              } else if ((trainer.specialities[j].speciality_id === 2)) {
                biomass_trainers.push(trainer);
              } else if ((trainer.specialities[j].speciality_id === 3)) {
                geothermal_trainers.push(trainer);
              } else if ((trainer.specialities[j].speciality_id === 4)) {
                hydro_trainers.push(trainer);
              } else if ((trainer.specialities[j].speciality_id === 5)) {
                solar_trainers.push(trainer);
              } else if ((trainer.specialities[j].speciality_id === 6)) {
                wind_trainers.push(trainer);
              }
            }
          }
        }
        
        
        
        
        
        
        setGeoTrainers(geothermal_trainers);
        setBiofuelTrainers(biofuel_trainers);
        setBiomassTrainers(biomass_trainers);
        setWindTrainers(wind_trainers);
        setHydroTrainers(hydro_trainers);
        setSolarTrainers(solar_trainers);
        setOperationTypes("all");
        setTrainers(res.data);
        setTrainersMemo(res.data);
        const unAssignedTrainers = res.data.filter(
          (each) => !trainerIds.includes(each.id.toString() as string)
        );

        setFilteredTrainers(unAssignedTrainers);
        setTrainers(unAssignedTrainers);
      })
      .catch((e) => e);
  }, [trainerIds]);

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();

    const filtered = trainers?.filter((each) =>
      each.name.toLowerCase().includes(searchTerm)
    );

    setFilteredTrainers(filtered);

    if (filtered && filtered.length > 0) setIsSearchEmpty(false);
    else setIsSearchEmpty(true);
  };

  const pickUser = (index: number) => {
    const user = filteredTrainers?.at(index);
    const indexOfUser = pickedTrainers?.findIndex((each) => each.id == user?.id);

    if (indexOfUser >= 0) {
      pickedTrainers?.splice(indexOfUser, 1);
      setPickedTrainers([...pickedTrainers]);
    } else {
      setPickedTrainers([
        user as IUserProfile,
        ...(pickedTrainers as IUserProfile[]),
      ]);
    }
  };

  const isPicked = (index: number): boolean => {
    const user = filteredTrainers?.at(index);

    const userIndex = pickedTrainers?.findIndex((each) => each.id === user?.id);

    return userIndex >= 0 ? true : false;
  };

  const assignCourseToTrainers = async () => {

    setIsEnrolling(true);

    const data = {
      trainers: pickedTrainers.map((each) => each.id.toString()) as string[],
    };

    try {
      const response = await AdminHelpers.assignTrainertoCourse(
        data,
        selectedCourseId.toString()
      );
      if (response) updateRecord();

      setPickedTrainers([]);
      onClosed();

      toast({
        title: "Assign Trainer",
        description: response.message,
        status: "success",
        duration: 3000,
      });
    } catch (error) {
      toast({
        title: "Assign Trainer",
        description: "Something went Wrong. Try again later",
        status: "error",
      });
    } finally {
      setIsEnrolling(false);
    }
  };

  const closeModal = () => {
    setPickedTrainers([]);

    setTrainers(trainersMemo);

    onClosed();
  };

  function updateOperation(operation_type: string): void {
    if (operation_type === "biomass") {
      const unassigned = biomasstrainers.filter(
        (each) => !trainerIds.includes(each.id.toString() as string)
      );
      setFilteredTrainers(unassigned);
      setOperationTypes("biomass");
    } else if (operation_type === "biofuel") {
      const unassigned = biofueltrainers.filter(
        (each) => !trainerIds.includes(each.id.toString() as string)
      );
      setFilteredTrainers(unassigned);
      setOperationTypes("biofuel");
    } else if (operation_type === "solar") {
      const unassigned = solartrainers.filter(
        (each) => !trainerIds.includes(each.id.toString() as string)
      );
      setFilteredTrainers(unassigned);
      setOperationTypes("solar");
    } else if (operation_type === "hydro") {
      const unassigned = hydrotrainers.filter(
        (each) => !trainerIds.includes(each.id.toString() as string)
      );
      setFilteredTrainers(unassigned);
      setOperationTypes("hydro");
    } else if (operation_type === "geothermal") {
      const unassigned = geotrainers.filter(
        (each) => !trainerIds.includes(each.id.toString() as string)
      );
      setFilteredTrainers(unassigned);
      setOperationTypes("geothermal");
    }
    else if (operation_type === "wind") {
      const unassigned = windtrainers.filter(
        (each) => !trainerIds.includes(each.id.toString() as string)
      );
      setFilteredTrainers(unassigned);
      setOperationTypes("wind");
    }
    else if (operation_type === "all") {
      setFilteredTrainers(trainers);
      setOperationTypes("all");
    }
  }

  return (
    <>
      <Modal
        closeOnOverlayClick={false}
        isOpen={isOpened}
        onClose={closeModal}
        scrollBehavior="inside"

      >
        <ModalOverlay />
        <ModalContent borderRadius={5}>
          <ModalHeader color="brand.2" fontSize={22}>
            Assign course to trainer
          </ModalHeader>
          <ModalCloseButton size="md" />
          <ModalBody pb={6}>
            <Flex justifyContent="space-between" alignItems="center" mb={3}>
              <InputGroup color="brand.subtitle" bg="white" mr="1rem">
                <Input
                  placeholder="Search trainers"
                  onChange={(e) => handleSearchChange(e)}
                  fontSize={12}
                  size="sm"
                />

                <InputRightElement
                  h="1.9rem"
                  pointerEvents="none"
                  children={<RiSearch2Line size="0.9rem" />}
                />
              </InputGroup>
              <Menu size={'sm'}>
                <MenuButton
                  as={Button}
                  rightIcon={<ChevronDownIcon />}
                  colorScheme="lightgray"
                  variant={"outline"}
                  size="sm"
                  fontSize={12}
                >
                  {operation === "biofuel"
                    ? "Biofuel"
                    : operation === "biomass"
                      ? "Biomass"
                      : operation === "geothermal"
                        ? "Geothermal"
                        : operation === "wind"
                          ? "Wind"
                          : operation === "solar"
                            ? "Solar"
                            : operation === "hydro"
                              ? "Hydro"
                              : "All"}
                </MenuButton>
                <MenuList fontSize={12}>
                  <MenuItem
                    onClick={() => updateOperation("all")}
                  >
                    See All
                  </MenuItem>
                  <MenuItem
                    onClick={() => updateOperation("hydro")}
                  >
                    Hydro
                  </MenuItem>

                  <MenuItem
                    onClick={() => updateOperation("biomass")}
                  >
                    Biomass
                  </MenuItem>
                  <MenuItem
                    onClick={() => updateOperation("biofuel")}
                  >
                    Biofuel
                  </MenuItem>
                  <MenuItem
                    onClick={() => updateOperation("geothermal")}
                  >
                    Geothermal
                  </MenuItem>

                  <MenuItem
                    onClick={() => updateOperation("wind")}
                  >
                    Wind
                  </MenuItem>
                  <MenuItem
                    onClick={() => updateOperation("solar")}
                  >
                    Solar
                  </MenuItem>
                </MenuList>
              </Menu>
            </Flex>

            {pickedTrainers.length > 0 && (
              <Box mb={2} justifyContent="center" display="flex">
                <Text fontSize={12} color="brand.2">
                  {" "}
                  {pickedTrainers?.length}{" "}
                  <Box color="brand.subtitle" as="span">
                    {" "}
                    trainers selected{" "}
                  </Box>
                </Text>
              </Box>
            )}

            <Divider />

            <VStack
              mt={4}
              divider={<StackDivider borderColor="gray.200" />}
              spacing={4}
              align="stretch"
            >
              {isSearchEmpty ? (
                <EmptySearchResult />
              ) : (
                filteredTrainers?.map((each, index) => (
                  <Flex key={index} justifyContent="space-between">
                    <HStack>
                      <Avatar size="xs" name={`${each.name} `} />
                      <Box>
                        <Text fontSize={11}>{`${each.name} `}</Text>
                        <Text color="#7883A7" fontSize="9px">
                          {each.email}
                        </Text>
                      </Box>
                    </HStack>

                    <Box
                      width={6}
                      color={isPicked(index) ? "#02A356" : "#959595"}
                      height={6}
                      borderRadius={20}
                      border="dotted"
                      justifyContent="center"
                      alignItems="center"
                      cursor="pointer"
                      onClick={() => pickUser(index)}
                    >
                      <Flex
                        direction="column"
                        justifyContent="center"
                        height="100%"
                        alignItems="center"
                        fontSize={16}
                      >
                        {isPicked(index) ? <BsCheck /> : <BsPlus />}
                      </Flex>
                    </Box>
                  </Flex>
                ))
              )}
            </VStack>
          </ModalBody>

          <ModalFooter>
            {pickedTrainers.length > 0 && (
              <Button
                colorScheme="red"
                mr={3}
                size="xs"
                isLoading={isEnrolling}
                fontSize={11}
                borderRadius={2}
                px={5}
                onClick={() => {
                  assignCourseToTrainers();
                }}
              >
                {" "}
                Done{" "}
              </Button>
            )}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
